import { path } from 'ramda'
import { isEmail, isMobilePhone, isURL } from 'validator'
import InputField from 'features/job-posting/FormFields/InputField'
import { isLengthGreaterThan } from '../../FormValidation/validators'
import { getValidationField, getFormStateField } from '../../helpers'

export const isMobile = (str) => str ? isMobilePhone(str, 'any') : true

const isLength = length => value => value.length === length

const REQUIRED = true

export const hasUserType = (props) => {
  const type = path(['me', 'type'], props)
  return ['MB', 'AP', 'ST'].includes(type)
}

const getConfig = (props) => [
  {
    key: 0,
    data: [
      [
        {
          component: InputField,
          id: 'firstName',
          text: 'First Name',
          error: getValidationField(props, 'firstName'),
          validation: [[isLengthGreaterThan(0), 'Minimum Name length of 1 is required.', REQUIRED]],
          invalidText: 'Please enter your first name',
          data: getFormStateField(props, 'firstName', ''),
          onChange: (event) => props.dispatch({ type: 'onChangeGeneric', value: event.target, preventDefault: event.preventDefault }),
          required: REQUIRED,
          disabled: false,
          custom: {
            className: 'mb-3',
            xs: '12',
            md: '6'
          }
        },
        {
          component: InputField,
          id: 'lastName',
          text: 'Last Name',
          error: getValidationField(props, 'lastName'),
          validation: [[isLengthGreaterThan(0), 'Minimum Name length of 1 is required.', REQUIRED]],
          invalidText: 'Please enter your last name',
          data: getFormStateField(props, 'lastName', ''),
          onChange: (event) => props.dispatch({ type: 'onChangeGeneric', value: event.target, preventDefault: event.preventDefault }),
          required: REQUIRED,
          disabled: false,
          custom: {
            className: 'mb-3',
            xs: '12',
            md: '6'
          }
        }
      ],
      [
        {
          component: InputField,
          id: 'emailAddress',
          text: 'Email Address',
          error: getValidationField(props, 'emailAddress'),
          validation: [[isEmail, 'Please enter an email address.', REQUIRED]],
          invalidText: 'Please enter an email address',
          data: getFormStateField(props, 'emailAddress', ''),
          onChange: (event) => props.dispatch({ type: 'onChangeGeneric', value: event.target, preventDefault: event.preventDefault }),
          required: REQUIRED,
          disabled: false,
          custom: {
            className: 'mb-3',
            xs: '12',
            md: '6'
          }
        },
        {
          component: InputField,
          id: 'phoneNumber',
          text: 'Phone',
          error: getValidationField(props, 'phoneNumber'),
          validation: [[isMobile, 'Please enter a valid phone number.']],
          invalidText: 'Please enter a valid phone number',
          data: getFormStateField(props, 'phoneNumber', ''),
          onChange: (event) => props.dispatch({ type: 'onChangeGeneric', value: event.target, preventDefault: event.preventDefault }),
          required: !REQUIRED,
          disabled: false,
          custom: {
            className: 'mb-3',
            xs: '12',
            md: '6'
          }
        }
      ],
      [
        {
          component: InputField,
          id: 'websiteAddress',
          text: 'Website',
          error: getValidationField(props, 'websiteAddress'),
          validation: [[isURL, 'Please enter a valid website url']],
          invalidText: 'Please enter a valid website url',
          data: getFormStateField(props, 'websiteAddress', ''),
          onChange: (event) => props.dispatch({ type: 'onChangeGeneric', value: event.target, preventDefault: event.preventDefault }),
          required: !REQUIRED,
          disabled: false,
          custom: {
            className: 'mb-3',
            xs: '12',
            md: '6'
          }
        },
        ...!hasUserType(props)
          ? [{
            component: InputField,
            id: 'memberNumber',
            text: 'Member Number',
            type: 'number',
            error: getValidationField(props, 'memberNumber'),
            validation: [[isLength(8), 'Please enter a valid member number.']],
            invalidText: 'Please enter a valid member number',
            data: getFormStateField(props, 'memberNumber', ''),
            onChange: (event) => props.dispatch({ type: 'onChangeGeneric', value: event.target, preventDefault: event.preventDefault }),
            required: !REQUIRED,
            disabled: false,
            custom: {
              className: 'mb-3',
              xs: '12',
              md: '6'
            }
          }]
          : []
      ]
    ]
  }
]

export default getConfig
